module.exports = __webpack_public_path__ + "static/media/icomoon.456eb926.ttf";